import axiosInstance from '../axios/axiosInstance';
import { useState, useCallback } from 'react';

export function useCadastro() {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const resetResultEquip = useCallback(() => {
    setResult('');
  }, []);

  const patch = useCallback(async (data) => {
    try {
      setLoading(true);
      const res = await axiosInstance.post(`equipamentoAr/`, data);
      setResult({ sucess: true });
      setLoading(false);
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        setLoading(false);
        return setResult({ error: 'ERR_NETWORK' });
      }
      const err = error.response?.data;
      setLoading(false);
      return setResult({ error: err });
    }
  }, []);

  return { result, patch, loading, resetResultEquip };
}

export function useCadastroPecasEquip() {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const patch = useCallback(async (data) => {
    try {
      setLoading(true);
      const res = await axiosInstance.post(`pecasInEquipamentosAr/`, data);
      setResult({ sucess: true });
      setLoading(false);
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        setLoading(false);
        return setResult({ error: 'ERR_NETWORK' });
      }
      const err = error.response?.data;
      setLoading(false);
      return setResult({ error: err });
    }
  }, []);

  const resetInfo = () => {
    setResult('');
  };

  return { result, patch, loading, resetInfo };
}
